<template>
  <select class="form-control" @input="updateValue($event.target.value)" ref="select" :value="value">
    <option disabled value="">Please select a country</option>
    <option>United Kingdom</option>
    <optgroup label="other countries">
      <option v-for="country in countries" :key="country.iso">{{country.name}}</option>
    </optgroup>
  </select>
</template>

<script>
  import countries from '@/utils/countries'

  export default {
    data () {
      return {
        countries: countries.filter(country => country.iso !== 'GB')
      }
    },
    methods: {
      updateValue (val) {
        this.$refs.select.value = val
        this.$emit('input', val)
      }
    },
    props: {
      value: String
    }
  }
</script>

<style scoped>

</style>
